import { render, staticRenderFns } from "./CastSection.vue?vue&type=template&id=06f57876&scoped=true&"
import script from "./CastSection.vue?vue&type=script&lang=js&"
export * from "./CastSection.vue?vue&type=script&lang=js&"
import style0 from "./CastSection.vue?vue&type=style&index=0&id=06f57876&scoped=true&lang=css&"
import style1 from "./CastSection.vue?vue&type=style&index=1&id=06f57876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f57876",
  null
  
)

export default component.exports